export default __webpack_public_path__ + "static/media/password.0338d8fa.svg";